import moment from 'moment';

export const changeToZeroZone = (date: any) => {
    return new Date(date).toLocaleString('en-US', { timeZone: 'America/Danmarkshavn' });
};
export const changeToZeroZoneDate = (date: string): Date => {
    let dateFormat = new Date();
    if (date) {
        dateFormat = new Date(date);
    }
    const dateUtc = new Date(
        dateFormat.getUTCFullYear(),
        dateFormat.getUTCMonth(),
        dateFormat.getUTCDate(),
        dateFormat.getUTCHours(),
        dateFormat.getUTCMinutes(),
        dateFormat.getUTCSeconds(),
    );
    return dateUtc;
};

export const changeToZeroZoneDateUTC = (date: string): Date => {
    let dateFormat = new Date();
    if (date) {
        dateFormat = new Date(date);
    }
    const dateUtc = new Date(
        Date.UTC(
            dateFormat.getUTCFullYear(),
            dateFormat.getUTCMonth(),
            dateFormat.getUTCDate(),
            dateFormat.getUTCHours(),
            dateFormat.getUTCMinutes(),
            dateFormat.getUTCSeconds(),
        ),
    );
    return dateUtc;
};

// The API serializes dates with an explicit offset (e.g. '2025-05-14T00:00:00+03:00').
// Converting them to UTC moved date-only values (expenseDate, dob, seanceDate, ...) one day
// back for every user east of UTC, so keep the offset the value was sent with instead.
export const changeToZeroMoment = (date: string | undefined | number | Date, form = 'YYYY-MM-DD HH:mm:ss') => {
    return moment.parseZone(date).format(form);
};
export const changeToZeroMomentDate = (date: string | undefined | number) => {
    return moment.parseZone(date).format('YYYY-MM-DD');
};
export const changeToZeroMomentNoFormat = (date: string) => {
    return moment.parseZone(date);
};

export const changeToZeroMomentToDate = (date: string | undefined | number | Date, form = 'YYYY-MM-DD HH:mm:ss') => {
    return moment.utc(date).add(moment(date).utcOffset(), 'minutes').format(form);
};
